// extracted by mini-css-extract-plugin
export default {"RefPillOcticon":"RefPill-module__RefPillOcticon--mMO0a","RefPillTruncate":"RefPill-module__RefPillTruncate--i837R","RefPillText":"RefPill-module__RefPillText--wIKFN"};